{
  "remove": "Entfernen"
}
